const infoItems = [
  {
    icon: 'ri-building-line',
    label: 'Entreprise',
    value: 'SOMINKA',
    extra: 'Entrepreneur individuel',
  },
  {
    icon: 'ri-user-line',
    label: 'Dirigeante',
    value: 'Amelia Anna Sominka',
  },
  {
    icon: 'ri-file-text-line',
    label: 'SIRET',
    value: '101 634 145 00011',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Adresse',
    value: '4 Rue Judaïque\n33000 Bordeaux, France',
  },
  {
    icon: 'ri-price-tag-3-line',
    label: 'Activité',
    value: '70.22Z – Conseil pour les affaires et autres conseils de gestion',
  },
];

export default function AboutContent() {
  return (
    <section className="py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#1A2B4A] mb-3">
              Qui sommes-nous
            </p>
            <h2 className="font-poppins text-3xl font-semibold text-[#1A2B4A] mb-5">
              L'activité
            </h2>
            <div className="w-12 h-0.5 bg-[#1A2B4A] mb-8"></div>
            <div className="space-y-5 text-gray-600 text-sm leading-relaxed">
              <p>
                SOMINKA est une activité indépendante de conseil basée à Bordeaux,
                dirigée par{' '}
                <strong className="text-[#1A2B4A]">Amelia Anna Sominka</strong>,
                spécialisée dans le conseil en gestion et en développement d'activité.
              </p>
              <p>
                L'objectif est d'accompagner les entrepreneurs dans leurs décisions
                et d'améliorer la performance de leur entreprise grâce à une approche
                structurée et personnalisée.
              </p>
              <p>
                L'approche repose sur l'écoute, l'analyse approfondie et la mise en
                place de solutions concrètes, adaptées à chaque situation.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8">
            <h3 className="font-poppins text-lg font-semibold text-[#1A2B4A] mb-6">
              Informations légales
            </h3>
            <ul className="flex flex-col gap-6">
              {infoItems.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center text-[#1A2B4A] flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">{item.label}</p>
                    <p className="text-sm font-medium text-gray-700" style={{ whiteSpace: 'pre-line' }}>
                      {item.value}
                    </p>
                    {item.extra && (
                      <p className="text-xs text-gray-400 mt-0.5">{item.extra}</p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
